export const permissions = JSON.parse(sessionStorage.getItem('management_permissions') || '{}');


export const staff_session = JSON.parse(sessionStorage.getItem('management_staff') || '{}');
